//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    }
});

class PredefinedMessages extends Component {
    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);


        this.state = {
            accordion: [false, false, false],
        };
    }

    toggleAccordion(tab) {

        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);

        this.setState({
            accordion: state,
        });
    }

    //-- Main function
    render() {
        const { classes, match, history } = this.props;
        const { id, shopname } = match.params;

        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/settings">{siteConstants.MENU_SETTINGS}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_PRE_MESSAGES}
                                </li>
                                <li style={{ paddingLeft: "625px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <Card>
                                        <CardHeader>
                                            <strong>{siteConstants.MENU_PRE_MESSAGES}</strong>
                                        </CardHeader>
                                        <CardBody>

                                            <strong>{siteConstants.MENU_ORDERS}</strong>
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Order confirmation</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer after they place their order.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Order Edited</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer after their order is edited (if you select this option).
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Order edited invoice</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer after their order is edited and they owe money (if you select this option).
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Order canceled</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer if their order is canceled (if you select this option).
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Order refund</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer if their order is refunded (if you select this option).
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Draft order invoice</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer when a draft order invoice is created. You can edit this email invoice before you send it.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Email cart from POS</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer when you email their cart from POS. Includes a link to buy online.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Abandoned checkout</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer if they leave checkout before they buy the items in their cart. Configure options in "checkout settings".
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">POS Exchange Receipt</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer after they complete an exchange in person and want to be emailed a receipt.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Gift card created</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer when you issue or fulfill a gift card.

                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Payment error</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer if their payment can’t be processed.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>


                                            <strong>Shipping</strong>
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Fulfillment request</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to a third-party fulfillment service provider when order items are fulfilled.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Shipping confirmation</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer when their order is fulfilled (if you select this option).

                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Shipping update</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer if their fulfilled order’s tracking number is updated (if you select this option).
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>


                                            <strong>Customer</strong>
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Customer account invite</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer with account activation instructions. You can edit this email before you send it.
                                                               </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Customer account welcome</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer when they complete their account activation.
                                                                    </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Customer account password reset</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent automatically to the customer when they ask to reset their accounts password.
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 borderBottom">
                                                        <Col xs="2">
                                                            <a href="/predefined-messages-details/id" className="fontBold">Contact customer</a>
                                                        </Col>
                                                        <Col xs="10">
                                                            <FormGroup>
                                                                Sent to the customer when you contact them from the orders or customers page. You can edit this email before you send it.
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getProduct, deleteProduct } = state;
    return {
        language,
        getProduct,
        deleteProduct
    };
}
const Nonnectednotifications = connect(mapStateToProps)(withStyles(styles)(PredefinedMessages));
export { Nonnectednotifications as PredefinedMessages };